export const CYB_BROADCAST_CHANNEL = 'cyb-broadcast-channel';
export const CYB_QUEUE_CHANNEL = 'cyb-queue-channel';
